// extracted by mini-css-extract-plugin
export default {"dialogServiceContainer":"MP5WbJ_ASxAoXM9NQxUQ","addToBasketRecsContainer":"HMePWWf9pn2OZR3N77JQ","addToBasketRecsContainerHasCarousel":"NFl5cPt0pe3GP72rh9_Q"};